import React from "react";

import "../scss/Elements/_tables.scss";
import { Helmet } from "react-helmet";
import { useTranslationHook } from "../hooks/UseTranslationHook";
import { AssetsTableAxios } from "../components/Tables/AssetsTable";

function Assets() {
  const { titleAssetsString } = useTranslationHook();

  return (
    <div className="table-module-container">
      <Helmet>
        <title>{titleAssetsString}</title>
      </Helmet>
      <div className="datatable">
        <AssetsTableAxios />
      </div>
    </div>
  );
}

export default Assets;
